import React from "react";
import { Wrench, ShieldCheck, Package, CheckCircle } from "lucide-react";
import { motion } from "framer-motion";
import ReusableBanner from "../Components/Banner";
import l5 from '../assets/Services_Affordable.webp'
import l6 from '../assets/Repair_Reliable-repair.webp'
import l7 from '../assets/Repair_Spare-Parts.webp'
import ddd from '../assets/ddd.webp'
import ListWithIcon from "../Components/ListWithIcon";
import HeadingBlock from "../Components/HeadingBlock";
import { Helmet } from "react-helmet";
const RepairM = () => {
    const bullets3 = [
  { title: "Affordable Repairs",
    desc:"From minor issues to major breakdowns, handled by experts."
   },
  { title: "Maintenance Packages ",
    desc:"From minor issues to major breakdowns, handled by experts."
   },
];
  return (
    <>
     <Helmet>
        <title>Low Price Rapair & Maintenance</title>

        <meta
          name="description"
          content="From spare parts to advanced repairs, we are here to keep your drone and your journey — running smoothly, without heavy costs."
        />

        <link
          rel="canonical"
          href="https://dronedidi.co.in/repair_and_maintenance"
        />
      </Helmet>
    <ReusableBanner
  bgImage={l5}
  title={<span>Affordable Repair & Maintenance - Because <span className="text-green-400">Dreams Shouldn't</span> Stop</span>}
  subtitle="“Fix small problems before they break big dreams.”"
  height="h-[70vh]"
  fixedAttachment={true}
  align="center"
  // cta={{ text: "Get started", href: "/signup" }}
/>

<section className="w-full relative py-10 px-6 md:px-16 overflow-hidden">
  {/* Gradient background (30% width on left side) */}
  <div className="absolute inset-y-0 left-0 w-[30%] lg:[60%] bg-gradient-to-b from-green-100 via-green-200 to-green-800 rounded-2xl lg:rounded-[100%_0px] hidden md:block"></div>

  <div className="relative lg:max-w-[80%] mx-auto flex flex-col lg:flex-row items-center gap-10 z-10">
    {/* Left Side - Image/Illustration */}
    <div className="w-full lg:w-1/2 relative">
      <motion.img
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        src={l6} // replace with actual image
        alt="Drone Didi Training"
        className="w-full relative z-20 drop-shadow-xl"
      />
    </div>

    {/* Right Side - Content */}
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="w-full lg:w-1/2 relative z-20"
    >
      <HeadingBlock
        subtitle="Keep Your Drone in Top Shape"
        title="Reliable repair, maintenance, and spare parts –"
        align="left"
        highlight="all under one roof."
      />

      {/* About Text */}
      <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-6">
        We know how important your drone is to your work and your independence.
        That’s why we offer quick, affordable, and reliable repair and
        maintenance services – so that no breakdown can shatter your dreams.
      </p>

      <h1 className="bg-green-100 p-5 uppercase italic font-extrabold text-gray-600">
        How We Keep You Flying
      </h1>

      <ListWithIcon
        items={bullets3}
        icon={CheckCircle}
        size="md"
        layout="verticle"
        iconColor="text-green-600"
        variant="soft"
        iconBg="bg-green-50"
        className="my-6"
      />
    </motion.div>
  </div>
</section>

{/* Spare Parts Hub - Split Layout with Image + Features */}
<section className="relative py-20 mb-10 px-6 md:px-16 bg-gradient-to-b from-green-50 via-white to-green-50 overflow-hidden">
  <div className="lg:max-w-[80%] mx-auto  grid md:grid-cols-2 gap-14 items-center relative z-10">
    
  

    {/* Right Side - Heading + Features */}
    <div>
      <HeadingBlock
        title="Spare Parts & "
        align="left"
        highlight="Essentials Hub"
      />

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="text-gray-600 mb-10 text-lg max-w-lg"
      >
        From spare parts to advanced repairs, we are here to keep your drone and
        your journey running smoothly, without heavy costs.
      </motion.p>

      {/* Feature List */}
      <div className="space-y-10">
        {[
          {
            icon: <CheckCircle className="w-8 h-8 text-green-700" />,
            title: "100% Authentic Parts",
            desc: "No fakes, no risks – only original and trusted components.",
          },
          {
            icon: <Package className="w-8 h-8 text-green-700" />,
            title: "Ready Availability",
            desc: "Quick shipping and stock on hand so you don’t lose time.",
          },
          {
            icon: <Wrench className="w-8 h-8 text-green-700" />,
            title: "Expert Guidance",
            desc: "We’ll help you choose the right spare part for your exact needs.",
          },
        ].map((item, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: i * 0.2 }}
            className="flex items-start gap-5 group"
          >
            {/* Icon wrapper */}
            <div className="p-3 rounded-xl bg-green-100 group-hover:bg-green-200 transition relative">
              <span className="absolute inset-0 rounded-xl bg-green-200/50 blur-lg opacity-0 group-hover:opacity-70 transition"></span>
              <div className="relative">{item.icon}</div>
            </div>

            {/* Text */}
            <div>
              <h4 className="font-bold text-lg text-gray-800 mb-1 relative inline-block">
                {item.title}
                <span className="block w-10 h-1 bg-green-500 mt-1 rounded-full"></span>
              </h4>
              <p className="text-gray-600">{item.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
      {/* Left Side - Image / Illustration */}
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.7 }}
      className="flex justify-start"
    >
      <img
        src={l7} // replace with your drone/spare parts image
        alt="Spare Parts"
        className="w-full max-w-md md:max-w-lg drop-shadow-2xl rounded-2xl"
      />
    </motion.div>
  </div>

  {/* Background Shapes */}
  <div className="absolute top-10 right-0 w-72 h-72 bg-green-200/30 rounded-full "></div>
  <div className="absolute bottom-0 left-0 w-60 h-60 bg-orange-500/20 rounded-full"></div>
</section>
<section className="relative py-16 ">
  <div className="container mx-auto flex flex-col md:flex-row items-center relative">
    {/* Left Drone Image */}
    <motion.div
       initial={{ opacity: 0, x: -50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.9 }}
    className="relative md:w-1/2 flex justify-center">
      <img
        src={ddd}
        alt="Drone"
        className="relative -mt-12"
      />
    </motion.div>
  
    {/* Right Content */}
    <div className="md:w-1/2 bg-gradient-to-b from-green-50 via-green-100 to-green-200 shadow-xl rounded-2xl p-8 lg:-ml-12 relative z-10">
     <h2 className="text-5xl font-bold text-gray-900 mb-4 drop-shadow-[3px_2px_1px_rgb(221,152,66)]">
  Peace of Mind, Every Time
</h2>

      <p className="text-gray-600 mb-4 text-lg">
        We know your drone isn’t just equipment; it’s your independence, your
        productivity, your dream. That’s why our repairs, maintenance, and parts
        hub are built around one promise: keeping you and your drone in the sky.
      </p>
      <p className="text-gray-600 mb-6 italic">
        "From spare parts to advanced repairs, we are here to keep your drone
        and your journey — running smoothly, without heavy costs."
      </p>
 
    </div>
  </div>
</section>

      </>
  );
};

export default RepairM;
